import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
import "./PaymentStatus.css";

function PaymentStatus({ baseUrl }) {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("checking"); // checking | success | pending | failed | error

    const merchantOrderId = searchParams.get("merchantOrderId");
    const plan = searchParams.get("plan");

    useEffect(() => {
        if (!baseUrl || !merchantOrderId) return;

        let isMounted = true;

        const checkStatus = async () => {
            try {
                const storedUser = sessionStorage.getItem("user");
                const email = storedUser ? JSON.parse(storedUser)?.email : "";

                const { data } = await axios.get(
                    `${baseUrl}/api/payment/phonepe/status/${merchantOrderId}`,
                    { params: email ? { email } : {} }
                );

                if (!isMounted) return;

                if (data.success) {
                    if (data.user) {
                        sessionStorage.setItem("user", JSON.stringify(data.user));
                    }
                    setStatus("success");
                } else if (data.state === "PENDING") {
                    setStatus("pending");
                } else {
                    setStatus("failed");
                }
            } catch (error) {
                console.error(
                    "Payment status check failed:",
                    error.response?.data || error.message
                );
                if (isMounted) setStatus("error");
            }
        };

        checkStatus();

        return () => {
            isMounted = false;
        };
    }, [baseUrl, merchantOrderId]);

    return (
        <>
            <Navbar baseUrl={baseUrl} />
            <div className="payment-status-page">
                <div className="payment-status-box">
                    {status === "checking" && (
                        <>
                            <div className="payment-status-spinner" />
                            <h2>Confirming your payment...</h2>
                            <p>Please don't close this page.</p>
                        </>
                    )}

                    {status === "success" && (
                        <>
                            <h2 className="payment-status-success">Payment successful!</h2>
                            <p>
                                Your {plan ? `${plan} plan` : "subscription"} is now active.
                            </p>
                            <Link to="/" className="payment-status-home-link">
                                Go to Home
                            </Link>
                        </>
                    )}

                    {status === "pending" && (
                        <>
                            <h2>Payment still processing</h2>
                            <p>This can take a minute. Please refresh this page shortly.</p>
                        </>
                    )}

                    {(status === "failed" || status === "error") && (
                        <>
                            <h2 className="payment-status-failed">Payment not completed</h2>
                            <p>
                                If any amount was deducted, it will be refunded automatically.
                                Please try again or contact support.
                            </p>
                            <Link to="/" className="payment-status-home-link">
                                Go to Home
                            </Link>
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PaymentStatus;
